import { RESET_STATE } from '../auth/constants';
import { WORK_TYPES_SET, WORK_TYPE_SET } from './constants';

const initialState = {};

type State = {};

type Action = {
    +type: string,
    +payload: any
};

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case WORK_TYPES_SET:
            return action.payload;
        case WORK_TYPE_SET:
            return {
                ...state,
                [action.payload.id]: action.payload
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
